import { MatchHeight } from "js-match-height";

import slickSlider from "../../common/slickSlider.js";

export default () => {
  if (document.querySelector(".is-page-editor")) {
    return;
  }

  document.querySelectorAll(".js-section-navigator").forEach((el, i) => {
    const parentIndex = i + 1;
    const cards = el.querySelectorAll(".js-rich-text-card");
    const titles = [...el.querySelectorAll(".js-rich-text-card__title")].map(
      (title) => title.innerHTML,
    );

    if (!cards || cards.length < 2) {
      return;
    }

    // **** Create Fake Card appearance at end of the slider *****************/
    const blankImage = document.createElement("div");
    blankImage.classList.add("rich-text-card__image");
    const firstImage = cards[0].querySelector(".js-rich-text-card__image");
    const secondImage = cards[1].querySelector(".js-rich-text-card__image");
    let activeSlide = 0;

    const imageDecorator = document.createElement("div");

    imageDecorator.classList.add("rich-text-card__decorative-images");
    imageDecorator.append(
      firstImage ? firstImage.cloneNode() : blankImage.cloneNode(),
    );
    imageDecorator.append(
      secondImage ? secondImage.cloneNode() : blankImage.cloneNode(),
    );
    cards[cards.length - 1].append(imageDecorator);

    // **** Create Slick Sider ******************************************/
    const customPaging = (slider, i) =>
      `<button class="js-section-navigator__control-link section-navigator__control-link js-custom-slide-control" type="button" aria-label="${titles[i]}"/>${titles[i]}</button>`;

    const conf = {
      speed: 500,
      fade: true,
      customPaging,
      appendDots: el.querySelector(".js-section-navigator__controls"),
      responsive: [
        {
          breakpoint: 909,
          settings: {
            fade: false,
          },
        },
      ],
    };

    const elSlider = el.querySelector(".js-section-navigator__slider");
    const slider = slickSlider(elSlider, conf, (event, slick) => {});

    // **** Handle URL hash tag controls *******************************/
    cards.forEach((card, cardIndex) => {
      card.addEventListener("focus", (event) => {
        slider.slick("slickGoTo", cardIndex);
      });
    });

    // **** Set Equal heights for each card ********************************/
    const id = `section-navigator-${parentIndex}`;
    el.setAttribute("id", id);
    const matchHeight = new MatchHeight(`#${id} .rich-text-card`);

    if (window.location.hash) {
      const hash = window.location.hash;
      if (hash.startsWith("#section-navigator")) {
        const hashParts = hash.split("-");
        if (parseInt(hashParts[2], 10) === i + 1) {
          slider.slick("slickGoTo", parseInt(hashParts[3], 10) - 1);
        }
      }
    }

    // Adding tracking for hash tag events
    const rightColumn = el.querySelector(".js-section-navigator__column-right");
    // create spacer elements for all cards.
    for (let index = 0; index < cards.length; index++) {
      const spacer = document.createElement("div");
      spacer.classList.add("section-navigator__spacer-card");
      spacer.dataset.slideIndex = index;
      spacer.setAttribute(
        "id",
        `section-navigator-${parentIndex}-${index + 1}`,
      );
      spacer.setAttribute("tabindex", "-1");
      rightColumn.prepend(spacer);

      spacer.addEventListener("focus", (e) => {
        slider.slick("slickGoTo", index);
      });
    }

    slider.on("afterChange", (event, slick, currentSlide) => {
      activeSlide = currentSlide;
      document.querySelector(`#slick-slide-control${i}${activeSlide}`).focus();
    });

    // **** Handle Up Down Key controls *************************/
    // declaring an array so we can find the next and prev controls
    const controlLinks = el.querySelectorAll(
      ".js-section-navigator__control-link",
    );

    controlLinks.forEach((link, i) => {
      link.addEventListener("click", (e) => {
        activeSlide = i;
      });

      link.addEventListener("keydown", (e) => {
        switch (e.key) {
          case "Up":
          case "ArrowUp":
            e.preventDefault();
            slider.slick("slickPrev");
            if (i > 0) {
              controlLinks[i - 1].focus();
            }
            break;
          case "Down":
          case "ArrowDown":
            e.preventDefault();
            slider.slick("slickNext");
            if (i < controlLinks.length - 1) {
              controlLinks[i + 1].focus();
            }
            break;
          default:
        }
      });
    });
  });
};
